module.exports = __webpack_public_path__ + "img/icon.3937f156.jpeg";